import { useState } from "react";
import { Copy, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

export const CopyButton = ({ text, label = "Copy", testId = "copy-btn", className = "" }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(text);
    setCopied(true);
    toast.success("Copied to clipboard");
    setTimeout(() => setCopied(false), 1600);
  };
  return (
    <button
      data-testid={testId}
      onClick={copy}
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium surface hover:border-[var(--glow)] transition-colors ${className}`}
    >
      {copied ? <Check size={15} color="var(--success)" weight="bold" /> : <Copy size={15} />}
      {copied ? "Copied" : label}
    </button>
  );
};
